import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/boardable_logo_white.svg")